import { T } from '@angular/cdk/keycodes';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { AppService } from 'src/app/services/app/app.service';
import { CommonService } from 'src/app/services/common/common.service';
import { DocumentService } from 'src/app/services/document/document.service';
import { GlobalService } from 'src/app/services/global/global.service';
import { UserManagementService } from 'src/app/services/user_management/user-management.service';
import { AddDocumentComponent } from '../add-document/add-document.component';
import { ViewDocumentsComponent } from '../view-documents/view-documents.component';

@Component({
  selector: 'app-upload-document',
  templateUrl: './upload-document.component.html',
  styleUrls: ['./upload-document.component.scss']
})
export class UploadDocumentComponent {
  public isSpinnerLoading:boolean=false;
  public imageURL:string=GlobalService.imageURL;
  public isFileUploaded:boolean=false;
  constructor(private commonService:CommonService, private docService:DocumentService,private appService:AppService,
    private dialogRef:MatDialogRef<UploadDocumentComponent>,private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public dialogData:any,private spinner:NgxSpinnerService,private userService:UserManagementService){}
  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    if(this.dialogData.data){
      this.isFileUploaded=true;
    }
  }
  public files:File[]=[]
  onSelect(event) {
    this.files.push(...event.addedFiles);
  }
  onDeleteFile(){
   this.isFileUploaded=false;
  }
  onRemove(event) {
    this.files.splice(this.files.indexOf(event), 1);
  }
  onSave(){
    this.isSpinnerLoading=true;
    this.spinner.show()
    let formData=new FormData()
    formData.append('pack_id',this.dialogData.pack_id)
    formData.append('employee_id',this.dialogData.e_id)
    formData.append('doc',this.files[0])
    formData.append('doc_pac_id',this.dialogData.doc_id)
    this.docService.empUploadDocument(formData).subscribe({
      next: (success: any) => {
        this.isSpinnerLoading = false;
        this.spinner.hide();
        if (success.status == 200) {
          this.appService.showToastMessage("success", success.msg);
          this.dialogRef.close({ data_added: true });
        }
      },
      error: (error: any) => {
        this.commonService.handleError(error);
      },
    });
  }
  onDownload(data:string){
    this.appService.downloadFile(data,'upload_doc')
  }
  onCancel(){}
  getFileName(url:string){
    let newArr=url.split('/')
    return newArr[newArr.length-1]
  }
  onView(){
    const dialogRef = this.dialog.open(ViewDocumentsComponent, {
      width: '60%', minWidth: '280px', height: '90%', maxHeight: '700px',maxWidth:'800px',
      enterAnimationDuration: '300ms', exitAnimationDuration: "300ms", panelClass: "hire",
      data:this.dialogData.data
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result && result["data_added"] == true) {
        // this.getPackDocList(this.packId)
      }
    });
  }
}
